import API from '@/lib/API.js'
import comun from './comun.js'
const tipodocumento = {
    namespaced: true,
    state: {
            Lista: [],
            Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getTipo_documento();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Tipo_documento.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
    },
    getters: {
        getTipo_documento: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default tipodocumento;